import { Typography } from "antd";

function TitleCard({ title }) {
  return <Typography.Text style={{ color: "#052987", fontWeight: 600 }}>{title}</Typography.Text>;
}

const SubTitleCard = ({ subTitle }) => {
  return <Typography.Text className="title-sub-title-card">{subTitle}</Typography.Text>;
};

export { SubTitleCard, TitleCard };
